"use client";

import React, { useEffect } from "react";
import { useSelector } from "react-redux";

import HelpOverLayButton from "@/app/shared-components/help-overlay-button/help-overlay-button-wizard";
import { useWizard } from "@/app/shared-providers/wizard-context-provider";
import Logo from "@/components/molecules/logo-component/logo";
import MedicalDeclineSection from "@/components/organisms/medical-section/medical-decline";
import useGtmPageView from "@/hooks/gtm/use-gtm-page-view";
import useCustomPageTracking from "@/hooks/page-tracking/use-custom-page-tracking";
import useUpdateProgressBar from "@/hooks/progress/use-update-progress-bar";
import useMediaQuery from "@/hooks/use-media-query/use-media-query-enhanced";
import { useLoading } from "@/providers/loading-provider";
import { RootState } from "@/store/root-reducer";

interface ClientComponentProps {
  unableToQuoteContent: any;
  pageName: string;
}

function MedicalDeclineWrapper({
  unableToQuoteContent,
  pageName,
}: Readonly<ClientComponentProps>) {
  const { referenceId } = useSelector((state: RootState) => state.quote);
  const { showLoading, hideLoading } = useLoading();
  const [isdesktop, isReady] = useMediaQuery("(min-width: 600px)");

  const { pageReferrer, pageUrl, pageTitle } = useCustomPageTracking(pageName);

  useGtmPageView({
    userId: "",
    quoteId: "",
    pageReferrer,
    pageUrl,
    pageTitle,
  });

  const { current } = useWizard();
  useUpdateProgressBar(current?.progressBarPercentage ?? -1);

  useEffect(() => {
    if (!referenceId) {
      showLoading();
    } else {
      hideLoading();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [referenceId]);

  if (!isReady) return null;

  return (
    <div
      data-testid="medical-decline-wrapper-id"
      className=" bg-surface-neutral-option-2 "
    >
      <div className="w-full h-full">
        <div className="min-h-screen bg-surface-neutral-option-2">
          <div className={`  max-w-[1200px] mx-auto my-0 w-[100%] relative`}>
            <main className="md:pt-spacing-xl lg:pt-spacing-xxl md:pb-spacing-xxl pt-spacing-m pb-spacing-m ">
              <div
                className=" md:gap-spacing-l gap-spacing-m xl:mx-auto lg:mx-[72px] 
      md:mx-[48px] mx-[24px] relative"
              >
                <div className="bg-dark-surface-accent-1-primary rounded-radius-xxl ">
                  <div className=" flex flex-col h-full">
                    <div className="text-surface-neutral-option-2 relative">
                      <HelpOverLayButton />
                      <Logo
                        color="white"
                        heightClass="h-[80px]"
                        size="xl"
                        showondesktop={isdesktop.toString()}
                      />
                    </div>
                    <MedicalDeclineSection
                      unableToQuoteContent={unableToQuoteContent}
                    />
                  </div>
                </div>
              </div>
            </main>
          </div>
        </div>
      </div>
    </div>
  );
}

export default MedicalDeclineWrapper;
